import React from 'react';
import { CarClass } from '@/entities/car-class';
import CarListCard from '../../shared/CarListCard';
import Reveal from '../../shared/Reveal';
import Typografed from '../../shared/Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    carsList: CarClass[];
};

const ServicesCarsList = ({ carsList }: Props) => {
    return (
        <div className="car-list__wrapper wrapper">
            {carsList.length > 0 ? (
                <ul className="car-list__list list-unstyled">
                    {carsList.map((car) => (
                        <Reveal key={car.id}>
                            <li className="car-list-card__item">
                                <CarListCard car={car} />
                            </li>
                        </Reveal>
                    ))}
                </ul>
            ) : (
                <div className="car-list__empty">
                    <Typografed>Автомобили не найдены</Typografed>
                </div>
            )}
        </div>
    );
};

export default ServicesCarsList;
